import { DefaultSeoProps } from 'next-seo'

export const SEO: DefaultSeoProps = {
  titleTemplate: '%s | Moonforge',
  defaultTitle: 'Moonforge',
  description: 'Where tokens are launched, managed, and traded — all in one flow. Built on @HyperEVM.',
  twitter: {
    cardType: 'summary_large_image',
    handle: '0xmoonforge',
    site: 'https://moonforge.finance',
  },
  openGraph: {
    title: 'Moonforge - Where tokens are launched, managed, and traded',
    description: 'Where tokens are launched, managed, and traded — all in one flow. Built on @HyperEVM.',
    images: [{ url: 'https://moonforge.finance/logo.svg' }],
  },
}
